import { render } from "./cpu.vue?vue&type=template&id=4585ab70&scoped=true"
import script from "./cpu.vue?vue&type=script&lang=js"
export * from "./cpu.vue?vue&type=script&lang=js"

import "./cpu.vue?vue&type=style&index=0&id=4585ab70&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4585ab70"]])

export default __exports__